import { productImageStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductImage";
import { StyledButton } from "@insite/mobius/Clickable";
import { GridItemStyle } from "@insite/mobius/GridItem";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

productImageStyles.compareCheckbox = {
    css: css`
        align-self: center;
        padding-top: 20px;
        ${TypographyStyle} {
            white-space: nowrap;
            color: ${getColor("primary")};
        }
        ${IconWrapper} {
            margin-left: 15px;
        }
    `,
};

productImageStyles.productImage = {
    img: {
        css: css`
            height: 180px;
            width: 180px;
        `,
    },
};

productImageStyles.productImage = {
    linkWrappingImage: {
        css: css`
            display: flex;
            justify-content: center;
        `,
    },
};

productImageStyles.wrapper = {
    css: css`
        ${StyledButton} {
            display: flex;
            justify-content: center;
        }
    `,
};
